<div class="container-fluid bg-primary">
    <footer class="d-flex flex-wrap  mt-0 mb-0 py-3 my-4">
        <p class="col-lg-12  m-auto text-lg-end text-md-center text-white px-lg-5">&copy; www.previncaseguros.com.ar</p>
    </footer>
</div>